module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (unset) { 
__p+='\n--- No Account ---\n';
 } else { 
__p+='\n'+
((__t=( code ))==null?'':_.escape(__t))+
' '+
((__t=( name ))==null?'':_.escape(__t))+
' ('+
((__t=( balance ))==null?'':_.escape(__t))+
')\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./parentpay/templates/paymentitem/option.html
// module id = 239
// module chunks = 0